import React, { useState } from 'react';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { func } from 'prop-types';
import {Loading, TableCustom, InputLista, AdvancedSearch, InputWithEnterEvent, Modal} from '../../common';
import { useLista } from '../../hooks/useLista';
import { ServerRequest } from '../../../utils/apiweb';
import { getDateToString } from '../../../utils/convert';
import { CloneObject } from '../../../utils/helpers';
import { APIS } from '../../../config/apis';

import './index.css';
import ExpedienteModal from '../ExpedienteModal';
import {TIPS} from "../../../consts/tips";

const ExpedientesModal = (props) => {

  //hooks
  const [state, setState] = useState({
      showMessage: false,
      loading: false,
      list: []
  });

  const [filters, setFilters] = useState({
    labels: [
      { title: 'Tipo expediente', field: 'descTipoExpediente', value: '', valueIgnore: '', fieldOriginal: 'idTipoExpediente', valueIgnoreOriginal: 0},
      { title: 'Expediente', field: 'expediente', value: '', valueIgnore: '' },
      { title: 'Etiqueta', field: 'etiqueta', value: '', valueIgnore: '' }
    ]
  });

  const [ formValues, formHandle, , formSet ] = useForm({
    idTipoExpediente: 0,
    descTipoExpediente: '', //no existe como control, se usa para tomar el text del tipo
    expediente: '',
    etiqueta: ''
  });

  const [showExpediente, setShowExpediente] = useState(null)

  const [, getRowLista ] = useLista({
    listas: ['TipoExpediente'],
    onLoaded: (listas, isSuccess, error) => {
      if (isSuccess) {

      }
      else {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: {
      key: 'TipoExpediente',
      timeout: 0
    }
  });

  const getDescTipoExpediente = (id) => {
    const row = getRowLista('TipoExpediente', id);
    return (row) ? row.nombre : '';
  }

  //definiciones
  const cellS = (props) =>    <div className='action'>
                                <div onClick={ (event) => handleClickSelect(props.value) } className="link">
                                <span className="material-symbols-outlined" title="Seleccionar">west</span>
                                </div>
                              </div>
  const cellV = (props) =>    <div className='action'>
                                <div onClick={ (event) => handleClickView(props.value) } className="link">
                                <span className="material-symbols-outlined" title="Ver">search</span>
                                </div>
                              </div>

  const tableColumns = [
    { Header: '', Cell: cellS, id:'select', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true },
    { Header: 'Tipo expediente', Cell: (props) => {
        const row = props.row.original;
        return getDescTipoExpediente(row.idTipoExpediente);
      }, id: 'tipo', accessor: 'tipo', width: '20%' },
    { Header: 'Expediente', accessor: 'detalleExpediente', width: '55%' },
    { Header: 'Fecha creación', Cell: (data) => (data.value) ? getDateToString(data.value, false) : '', accessor: 'fechaCreacion', width: '20%' },
    { Header: '', Cell: cellV, id:'abm', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true }
  ];


  //handles
  const handleClickSelect = (id) => {
    const row = state.list.find(f => f.id === id);
    props.onConfirm(id, CloneObject(row));
  }
  const handleClickView = (id) => {
    setShowExpediente(state.list.find(x => x.id === id))
  }

  const handleClickSinSeleccion = () => {
    props.onConfirm(0, null);
  }

  //callbacks
  const callbackNoSuccess = (response) => {
    response.json()
    .then((error) => {
      const message = error.message;
      ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
      setState(prevState => {
        return {...prevState, loading: false};
      });
    })
    .catch((error) => {
        const message = 'Error procesando respuesta: ' + error;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
          return {...prevState, loading: false};
        });
    });
  }
  const callbackError = (error) => {
    const message = 'Error procesando solicitud: ' + error.message;
    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
    setState(prevState => {
      return {...prevState, loading: false};
    });
  }

  //funciones
  function SearchExpedientes() {

      setState(prevState => {
          return {...prevState, loading: true, list: []};
      });
      
      const callbackSuccess = (response) => {
          response.json()
          .then((data) => {
              setState(prevState => {
                  return {...prevState, loading: false, list: data};
              });
          })
          .catch((error) => {
              const message = 'Error procesando respuesta: ' + error;
              ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
              setState(prevState => {
                  return {...prevState, loading: false};
              });
          });
      };

      const paramsUrl = `/filter?`+
      `idTipoExpediente=${formValues.idTipoExpediente}&`+
      `expediente=${encodeURIComponent(formValues.expediente)}&`+
      `etiqueta=${encodeURIComponent(formValues.etiqueta)}`;
      
      ServerRequest(
          REQUEST_METHOD.GET,
          null,
          true,
          APIS.URLS.EXPEDIENTE,
          paramsUrl,
          null,
          callbackSuccess,
          callbackNoSuccess,
          callbackError
      );        
  }

  function ApplyFilters() {
      UpdateFilters();
      SearchExpedientes();
  }
  function UpdateFilters() {
      let labels = [...filters.labels];
      labels.forEach((label) => {
          label.value = formValues[label.field];
      });
      setFilters(prevState => {
          return {...prevState, labels: labels};
      });
  }


  return (
    <div className='expediente-modal'>

      <Loading visible={state.loading}></Loading>

      <Modal
        size="xl"
        title="Selección de expediente"
        tipName={TIPS.NAME.MODALS.SELECCION_EXPEDIENTE_MODAL}
        onEscape={() => props.onDismiss()}
        body={(<>

              {showExpediente !== null && (
                <ExpedienteModal
                  disabled
                  data={{ entity: showExpediente }}
                  onDismiss={() => setShowExpediente(null)}
                />
              )}

              <AdvancedSearch
                formValues={formValues}
                formSet={formSet}
                labels={filters.labels.filter(f => f.value !== f.valueIgnore)}
                onSearch={ApplyFilters}
              >

                <div className='row form-basic'>
                    <div className="col-12 col-md-6 col-lg-4">
                        <label htmlFor="idPersona" className="form-label">Tipo expediente</label>
                        <InputLista
                            name="idTipoExpediente"
                            placeholder=""
                            className="form-control"
                            value={ formValues.idTipoExpediente }
                            onChange={({target}) =>{
                                let idTipoExpediente = 0;
                                let descTipoExpediente = '';
                                if (target.row) {
                                    idTipoExpediente = parseInt(target.value);
                                    descTipoExpediente = target.row.nombre;
                                }
                                formSet({...formValues, idTipoExpediente: idTipoExpediente, descTipoExpediente: descTipoExpediente});
                            }}
                            lista="TipoExpediente"
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <label htmlFor="expediente" className="form-label">Expediente</label>
                        <InputWithEnterEvent
                            name="expediente"
                            type="text"
                            placeholder=""
                            className="form-control"
                            value={ formValues.expediente }
                            onChange={ formHandle }
                            onEnter={ApplyFilters}
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <label htmlFor="etiqueta" className="form-label">Etiqueta</label>
                        <InputWithEnterEvent
                            name="etiqueta"
                            type="text"
                            placeholder=""
                            className="form-control"
                            value={ formValues.etiqueta }
                            onChange={ formHandle }
                            onEnter={ApplyFilters}
                        />
                    </div>
                </div>

              </AdvancedSearch>

              <TableCustom
                  showFilterGlobal={true}
                  className={'TableCustomBase m-top-30'}
                  columns={tableColumns}
                  data={state.list}
                  onClickRow={({ original }, colId) => colId !== 'abm' && props.onClickRow(original.id, original, colId)}
              />

        </>)}
        footer={(
              <div className='footer-action-container'>
                <button className="btn btn-outline-primary float-end" data-dismiss="modal" onClick={ (event) => handleClickSinSeleccion() }>Sin selección</button>
                <button className="btn back-button float-start" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
              </div>
        )}
      />

    </div>
  );
}

ExpedientesModal.propTypes = {
  onConfirm: func.isRequired,
  onDismiss: func.isRequired
};

export default ExpedientesModal;
